import classnames from 'classnames';
import { DropdownWrapper, SpDropdownItem } from 'components/shared/Dropdown';
import { FormattedMessage } from 'components/shared/Intl';
import { FC, useCallback } from 'react';
import { DropdownMenu, DropdownToggle } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { addonManagementFormViewSelected } from 'state/addonManagementForm/addonManagementForm.action';
import { getView } from 'state/addonManagementForm/filters/filters.selectors';
import type { ThunkDispatch } from 'state/state.common';

const addonManagementViews = ['default', 'primary', 'historic'] as const;
export type AddonManagementView = (typeof addonManagementViews)[number];

export const AddonManagementViewSelector: FC = () => {
  const dispatch = useDispatch<ThunkDispatch>();
  const selectedView = useSelector(getView);

  const selectView = useCallback(
    (view: AddonManagementView) => {
      dispatch(addonManagementFormViewSelected(view));
    },
    [dispatch],
  );

  const dropdownColor = selectedView === 'default' ? 'flat-secondary' : 'discreet-info';

  return (
    <DropdownWrapper className="btn-group border-start border-opacity-40" data-e2e="view-menu" openOnHover>
      <DropdownToggle
        aria-haspopup="listbox"
        variant="link"
        color={dropdownColor}
        className={classnames('btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2', {
          active: false,
        })}
        data-e2e="addon-management-view-dropdown-button"
      >
        <i className="icon">list</i>
        <FormattedMessage id={`addonManagement.view.${selectedView}`} defaultMessage={selectedView} />
      </DropdownToggle>
      <DropdownMenu data-e2e="addon-management-view-dropdown-menu" role="listbox">
        {addonManagementViews.map(view => (
          <SpDropdownItem
            key={view}
            active={view === selectedView}
            data-e2e={`view-dropdown-item-${view}`}
            onClick={() => {
              selectView(view);
            }}
          >
            <FormattedMessage id={`addonManagement.view.${view}`} />
          </SpDropdownItem>
        ))}
      </DropdownMenu>
    </DropdownWrapper>
  );
};
